<template>
    <div class="error">
        {{error_msg}}
        <div class="error_close" @click="close()">[ X ]</div>
    </div>
</template>

<style scoped>
    .error {
        display: block;
        position: fixed;
        z-index: 1002;
        background: rgba(219, 68, 68, 0.8);
        border-radius: 7px;
        left: 120px;
        top: 10px;
        color: #ffffff;
        width: auto;
        min-width: 200px;
        width:fit-content;
        height: auto;
        max-height: 100px;
        font-size: 12px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 10px;
        padding-right: 50px;
    }
    .error_close {
        display: block;
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
    }
</style>

<script>
export default {
    name: 'Error',
    props: ['error_msg'],
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>